<template>
  <div class="send-grid-contact-export-btn">
    <BtnBaseBlue
      color="blue darken-2"
      outlined
      @click="exportContacts"
      :loading="working"
      :disabled="working"
      >Export Sendgrid Contacts</BtnBaseBlue
    >
    <a ref="downloadLink" class="d-none" :href="linkHref">CSV Download Link</a>
  </div>
</template>

<script>
import Laravel from '@/services/Laravel'
import { format } from 'date-fns'
import * as TimeFormats from '@/constants/TimeFormats'

import BtnBaseBlue from '@/components/BtnBaseBlue'

export default {
  name: 'SendGridContactExportBtn',
  components: { BtnBaseBlue },
  data() {
    return {
      working: false,
      linkHref: '',
    }
  },
  methods: {
    async exportContacts() {
      this.working = true
      try {
        let { data: exportedCSV } = await Laravel.get(
          `/sendgrid-export`,
          {},
          {
            headers: {
              Accept: 'text/csv',
            },
          }
        )
        await this.setupDownloadLink(exportedCSV)
        await this.$refs.downloadLink.click()
      } catch (error) {
        Promise.reject(error)
      } finally {
        this.working = false
      }
    },
    setupDownloadLink(exportedCSV) {
      const blob = new Blob([exportedCSV])
      this.linkHref = window.URL.createObjectURL(blob)
      const date = format(Date.now(), TimeFormats.dateAndTimeForFiles)

      this.$refs.downloadLink.setAttribute(
        'download',
        `sendgrid-contact-export_${date}.csv`
      )
    }, // setupDownloadLink
  },
}
</script>

<style lang="scss" scoped></style>
